



































import { Component, Inject, Ref, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import ThanksItemPc from '@/components/ViewComponent/Thanks/AddThanksMessage/ThanksItem/ThanksItemPc.vue';
import UserFilter from '@/components/ViewComponent/Thanks/AddThanksMessage/Filter/UserFilter.vue';
import Cheeers3Icon from '@/components/Helper/Icon/Svg/Cheeers3Icon.vue';
import AddThanksMessageMixin from './add-thanks-message.mixin';

@Component<AddThanksMessagePc>({
  components: { Cheeers3Icon, ThanksItemPc, UserFilter },
  ...mapGetters('staff', ['currentStaff']),
})
export default class AddThanksMessagePc extends AddThanksMessageMixin {
  currentStaff!: StaffEntity;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  @Ref('refUserList') readonly refUserList: Vue | Element;

  get scrollEl(): Window | Element {
    if (this.refUserList instanceof Element) {
      return this.refUserList;
    }
    return this.refUserList.$el;
  }

  get filterItems() {
    if (!this.items.length) return [];
    const index = this.items.findIndex(user => user.id === this.currentStaff.id);
    const userTemp = [...this.items];
    if (index !== -1) {
      const currentUser = userTemp.splice(index, 1)[0];
      userTemp.unshift(currentUser);
    }
    return userTemp;
  }

  get itemStyle(): Partial<CSSStyleDeclaration> {
    let columnNumber = 1;
    if (this.$vuetify.breakpoint.sm) {
      columnNumber = 2;
    } else if (this.$vuetify.breakpoint.md) {
      columnNumber = 4;
    } else if (this.$vuetify.breakpoint.lg) {
      columnNumber = 5;
    } else if (this.$vuetify.breakpoint.xl) {
      columnNumber = 8;
    }
    return {
      flex: `0 0 calc(100% / ${columnNumber})`,
      maxWidth: `calc(100% / ${columnNumber})`,
    };
  }
  get contentHeight() {
    return `calc(100vh - ${260}px)`;
  }
}
